var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MyProjectsSection,{staticClass:"invoices-incoming",attrs:{"icon":"contractincoming","title":_vm.$t('invoices.incoming-invoices')}},[_c(_setup.InvoicesTable,{attrs:{"data":_setup.ingoingInvoices,"type":"incoming"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }